import http from "../../utils/httpClient"

class realtimeDataService {
  getRealtimeData = async (barcode) => {
    return await http.get(``)
  }
}
export default new realtimeDataService()
